import React from 'react';
import { useFormikContext } from 'formik';
import {
  useTranslator,
  formatMediumDate,
  DietIdEnum,
  useAppContext,
} from '@front-activerse/common-components';
import { dietSettings } from '../types';
import { Alert } from 'reactstrap';

export const Summary: React.FC = () => {
  const {
    consts: { APP_BRAND },
  } = useAppContext();
  const { t } = useTranslator();
  const { values } = useFormikContext<dietSettings>();
  const {
    weightValue,
    weightUnit,
    dietMode,
    goalWeightValue,
    dietType,
    dietLevel,
    spontaneousActivityLevel,
    activityLevel,
    sex,
    heightValue,
    heightUnit,
    dateOfBirth,
    dietVariant,
  } = values;

  const decimalSeparator = () => {
    const n = 1.1;
    const separator = n.toLocaleString().substring(1, 2);
    return separator;
  };

  return (
    <>
      <h2 className="mb-m title-large semi-bold">{t('goalSettings.summary.headline')}</h2>
      <p className="mb-xl text-text-variant-color">{t('goalSettings.summary.description')}</p>
      <div>
        <dl>
          <dt>{t('app.goalSettings.summary.list.currentWeight')}</dt>
          <dd>
            {String(weightValue).replace('.', decimalSeparator())} {weightUnit}
          </dd>
        </dl>
        <dl>
          <dt>{t('app.goalSettings.summary.list.goal')}</dt>
          <dd>{t(`app.goalSettings.summary.list.goal.${dietMode}`)}</dd>
        </dl>
        {dietMode !== 'stabilization' && (
          <dl>
            <dt>{t('app.goalSettings.summary.list.goalWeight')}</dt>
            <dd>
              {String(goalWeightValue).replace('.', decimalSeparator())} {weightUnit}
            </dd>
          </dl>
        )}
        <dl>
          <dt>{t('app.goalSettings.summary.list.dietType')}</dt>
          <dd>{dietType && t(`app.goalSettings.summary.list.dietType.${dietType}`)}</dd>
        </dl>
        {dietLevel && dietType === DietIdEnum.DIET_ID_CLASSIC && APP_BRAND === 'dtba' && (
          <dl>
            <dt>{t('app.goalSettings.summary.list.dietLevel')}</dt>
            <dd>{dietType && t(`app.goalSettings.summary.list.dietLevel.${dietLevel}`)}</dd>
          </dl>
        )}
        {dietLevel && dietType === DietIdEnum.DIET_ID_GLP1 && APP_BRAND === 'hashimoto' && (
          <dl>
            <dt>{t('app.goalSettings.summary.list.dietLevel')}</dt>
            <dd>{dietType && t(`app.goalSettings.summary.list.dietLevel.${dietLevel}`)}</dd>
          </dl>
        )}
        {dietLevel && APP_BRAND === 'oxy' && (
          <dl>
            <dt>{t('app.goalSettings.summary.list.dietLevel')}</dt>
            <dd>{dietType && t(`app.goalSettings.summary.list.dietLevel.${dietLevel}`)}</dd>
          </dl>
        )}
        {dietVariant && APP_BRAND === 'oxy' && (
          <dl>
            <dt>{t('app.dietSettings.summary.list.dietVersion')}</dt>
            <dd>{dietType && t(`app.goalSettings.summary.list.dietVersion.${dietVariant}`)}</dd>
          </dl>
        )}
        <dl>
          <dt>{t('app.goalSettings.summary.list.spontaneousActivity')}</dt>
          <dd>
            {t(`app.goalSettings.summary.list.spontaneousActivity.${spontaneousActivityLevel}`)}
          </dd>
        </dl>
        <dl>
          <dt>{t('app.goalSettings.summary.list.activity')}</dt>
          <dd>{t(`app.goalSettings.summary.list.activity.${activityLevel}`)}</dd>
        </dl>
        <dl>
          <dt>{t('biometric.summary.list.gender')}</dt>
          <dd>{t(`biometric.summary.list.gender.${sex}`)}</dd>
        </dl>
        <dl>
          <dt>{t('biometric.summary.list.birthDate')}</dt>
          <dd>{formatMediumDate(dateOfBirth)}</dd>
        </dl>
        <dl>
          <dt>{t('biometric.summary.list.height')}</dt>
          <dd>
            {String(heightValue).replace('.', decimalSeparator())} {heightUnit}
          </dd>
        </dl>
      </div>

      <Alert color="info" fade={false} className="mt-xl">
        <p className="small">{t('goalSettings.summary.changeMealsNotification')}</p>
      </Alert>
    </>
  );
};

export default Summary;
